// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"64":"6142dafa","769":"d65bd392"}[chunkId] + ".chunk.css";
};